// App.js
import React, { useEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import routes from './RouteLink';
import { Toaster } from 'react-hot-toast';
import { refreshFcmIfNeeded, startFcmRefreshInterval } from './Utilities/fcmService';
import auth from './Utilities/auth';

const router = createBrowserRouter(routes);

function App() {
  useEffect(() => {
    const userId = auth.getAdminId();
    if (!userId) return;

    // On app load: refresh token if 10 hours have passed
    refreshFcmIfNeeded(userId);

    // While app is open: refresh every 10 hours
    const intervalId = startFcmRefreshInterval(userId);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <>
      <RouterProvider router={router} />
      <Toaster position="top-right" />
    </>
  );
}

export default App;
